<div class="dialog">
    <h6>Enter New Option</h6>
    <div class="custom-form mt-4" [formGroup]="newIndustryForm" *ngIf="!isNewIndustryAdded">
        <input type="text" formControlName="new_industry_name">
    </div>
    <div class="button mt-4">
        <button class="white mr-3" (click)="cancel()">Cancel</button>
        <button class="orange ml-3" (click)="submit()">Save</button>
    </div>
</div>